import { ArticleStyle } from 'types'

// NOTE: this builds an object with custom css properties out of an article style, e.g.
// `{ h1: { font_family: "Helvetica" } }` would become `{ "--h1-font-family": "Helvetica" }`
export const buildArticleStyleCSSProperties = (
  ...articleStyles: (ArticleStyle | undefined | null)[]
): any | undefined => {
  const articleStyleCSSProperties: any = {}

  // later styles take precedence
  for (const articleStyle of articleStyles) {
    if (!articleStyle) continue

    for (const targetElement in articleStyle) {
      const targetElementCssProperties = articleStyle[targetElement as keyof ArticleStyle]

      for (const cssProperty in targetElementCssProperties) {
        articleStyleCSSProperties[`--${targetElement}-${cssProperty.replace('_', '-')}`] =
          targetElementCssProperties[cssProperty as keyof typeof targetElementCssProperties]
      }
    }
  }

  return articleStyleCSSProperties
}
